import { Component, Vue, Prop } from "vue-property-decorator";

@Component
class TagsList extends Vue{

  @Prop({ type: Number, default: -1 }) maxItems: number;
  @Prop({ type: Array, required:true }) items: unknown[];
  @Prop({ type: Function, default: v => v }) labelRenderer: Function;

  protected displayMore: boolean = false;

  renderItems(){

    let data = (this.maxItems === -1 || ! this.displayMore) ? this.items : this.items.slice(0, this.maxItems);

    return data.map(item => (
      <span class="tag m-r-10">
        <span class="cat-title">{this.labelRenderer(item)}</span>
        <span class="delete"  onClick={() => this.$emit("removeTag", item)}  />
      </span>
    ));
  }

  render() {


    return (
      <div class="tags-list">
        {this.renderItems()}
        {this.maxItems !== -1 && (this.items.length > this.maxItems) &&
        <span class="btn btn--link"
              onClick={() => this.displayMore = !this.displayMore}>
            {this.displayMore ? "Voir moins" : "Voir plus"}
          </span>
        }
      </div>
    );
  }

}

export default TagsList;

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-d0f8c848/tags-list.tsx" });